export type EventMap<T extends EventTarget> = Parameters<T["addEventListener"]>; 

export default class EventRegistry implements Disposable {

    list = [] as (() => void )[];

    // addEventListener<K extends keyof WindowEventMap>(type: K, listener: (this: Window, ev: WindowEventMap[K]) => any, options?: boolean | AddEventListenerOptions): void;
    add<T extends EventTarget>(target: T, name: EventMap<T>["0"], handler: EventMap<T>["1"], options?) {
        target.addEventListener(name, handler, options);
        this.list.push(() => {
            target.removeEventListener(name, handler, options);
        });
    }

    [Symbol.dispose]() {
        for (const element of this.list) {
            element();
        }
    }

}